import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="w-full px-4 md:px-8 lg:px-16 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-14 py-14 md:py-20">
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-2xl md:text-3xl font-heading font-bold mb-4">USFans Spreadsheet</h3>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Kompletny przewodnik po USFans Spreadsheet — najnowsze informacje, poradniki i zasoby w języku polskim.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors duration-300 cursor-pointer">
                <i className="ri-twitter-x-line text-white/70 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors duration-300 cursor-pointer">
                <i className="ri-facebook-line text-white/70 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-white/70 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-4 uppercase tracking-wider">Nawigacja</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer">Strona główna</Link></li>
              <li><Link to="/artykul/usfans-spreadsheet-poradnik-zakupowy" className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer">Poradnik zakupowy</Link></li>
              <li><Link to="/artykul/usfans-spreadsheet-kompletny-przewodnik" className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer">Przewodnik</Link></li>
              <li><a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200">Sklep główny</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-4 uppercase tracking-wider">Artykuły</h4>
            <ul className="space-y-2">
              {articles.slice(0, 5).map((a) => (
                <li key={a.slug}>
                  <Link to={`/artykul/${a.slug}`} className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200 cursor-pointer line-clamp-1">
                    {a.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-4 uppercase tracking-wider">Kategorie</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-white/50 text-sm hover:text-white/80 transition-colors duration-200">
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} USFans Spreadsheet. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/artykul/czy-usfans-spreadsheet-jest-bezpieczny" className="text-white/40 text-xs hover:text-white/60 transition-colors duration-200 cursor-pointer">Bezpieczeństwo</Link>
            <a href="#" className="text-white/40 text-xs hover:text-white/60 transition-colors duration-200">Polityka prywatności</a>
            <a href="#" className="text-white/40 text-xs hover:text-white/60 transition-colors duration-200">Zastrzeżenie</a>
          </div>
        </div>
      </div>
    </footer>
  );
}